import clamp from 'lodash/clamp';

const EXPONENTIAL_ZOOM_BASE = 2;
const LOGRAITHMIC_ZOOM_BASE = Math.log(2);

/* Convert exponential diagram zoom to a linear ak-range accessible value */
const getLinearZoom = (exponentialZoom: number) =>
	Math.log(exponentialZoom) / LOGRAITHMIC_ZOOM_BASE;

/** Convert linear ak-range value to exponential diagram zoom value */
const getExponentialZoom = (linearZoom: number) => EXPONENTIAL_ZOOM_BASE ** linearZoom;

/** Converts a deltaY (ctrl+scroll delta, or trackpad pinch gesture delta) */
export const getZoomFromDeltaY = (deltaY: number, currentZoom: number) => {
	const delta = clamp(deltaY, -0.1, +0.1);
	const newLinearZoom = clamp(getLinearZoom(currentZoom) - delta, -1, 1);
	return getExponentialZoom(newLinearZoom);
};
